/** Shared by web and iOS so every legal link uses the same documents. */
export const TERMS_URL = "https://convo.convergic.io/terms.html";
export const PRIVACY_URL = "https://convo.convergic.io/privacy.html";

export function isPlaceholderLegalUrl(url: string): boolean {
  return url.startsWith("PLACEHOLDER_");
}

/** Configuration check only; deployment verification checks HTTP reachability. */
export function hasLegalDocuments(): boolean {
  return [TERMS_URL, PRIVACY_URL].every(
    (url) => url.startsWith("https://") && !isPlaceholderLegalUrl(url),
  );
}
